export default {"src":"/_next/static/media/signup_icon_3.dcfd7113.svg","height":32,"width":32};